<template>
    <div
        class="control relative flex cursor-pointer items-stretch rounded-full border border-platinum p-1 text-center text-dark-gray"
        @click="toggleValue"
        :class="{ 'bg-white': toggleStyle === 'white', 'bg-light-gray': toggleStyle === 'light-gray' }"
    >
        <div
            class="selector"
            :class="{
                'translate-x-full': modelValue === options[1].value,
            }"
        />
        <div
            v-for="option in options"
            :key="option.label"
            :data-cy="`${option.label.toLowerCase().replace(/\s+/g, '-')}-selector-option`"
            :aria-selected="modelValue === option.value"
            class="relative flex flex-1 items-center justify-center space-x-1.5 px-2 py-3 transition-colors sm:space-x-2.5 sm:px-6"
            :class="{ 'text-white': modelValue === option.value }"
        >
            <img v-if="option.imgUrl" :src="option.imgUrl" alt="" class="size-5 sm:size-6" />
            <span class="font-semibold sm:text-lg">{{ option.label }}</span>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        modelValue: string
        toggleStyle?: 'white' | 'light-gray'
        options: { imgUrl?: string; value: string; label: string }[]
    }>(),
    {
        toggleStyle: 'white',
    },
)

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const toggleValue = (): void => {
    const currentIndex = props.options.findIndex(option => option.value === props.modelValue)
    const nextIndex = (currentIndex + 1) % props.options.length
    emit('update:modelValue', props.options[nextIndex].value)
}
</script>

<style scoped>
.selector {
    @apply absolute inset-y-0 left-0 m-1 bg-purple transform rounded-full;
    width: calc(50% - 0.25rem);
    transition:
        transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
